module.exports = __webpack_public_path__ + "static/media/google-play.01a98fa6.png";